module.exports = "//static.hsappstatic.net/academy-ai-assistant-lib/static-1.1113/img/playlist-avatar.png"